import { Trans, useTranslation } from 'react-i18next';
import {
  PaymentInterval,
  usePricingContext,
} from 'services/contexts/PricingContext/PricingProvider';
import theme from 'theme';
import {
  ComponentContainer,
  PaymentIntervalButton,
  SwitchContainer,
} from './styled';

const PaymentIntervalSwitch = () => {
  const { t } = useTranslation();
  const { isAnnualPaymentSelected, setPaymentInterval } = usePricingContext();

  return (
    <ComponentContainer>
      <SwitchContainer>
        <PaymentIntervalButton
          selected={!isAnnualPaymentSelected}
          onClick={() => setPaymentInterval(PaymentInterval.MONTH)}
        >
          {t('subscription:pricing:payMonthly')}
        </PaymentIntervalButton>

        <PaymentIntervalButton
          selected={isAnnualPaymentSelected}
          onClick={() => setPaymentInterval(PaymentInterval.YEAR)}
        >
          <span>
            {t('subscription:pricing:payAnnually')}
            <Trans
              i18nKey="subscription:pricing:save"
              values={{ discountPercentage: 20 }}
              components={{
                1: <span style={{ color: theme.palette.secondary.main }} />,
              }}
            />
          </span>
        </PaymentIntervalButton>
      </SwitchContainer>
    </ComponentContainer>
  );
};

export default PaymentIntervalSwitch;
